import { RadioButtonProps } from '@procore/core-react/dist/_typedoc/RadioButton/RadioButton.types.json';
import * as React from 'react';
export default {
  RadioButtonProps,
  React
};